import React from "react";
import Modal from "../../../components/Modal";

import LoadingComponent from "./loadable";

export default props => (
    <Modal width={680}>
        <LoadingComponent {...props} />
    </Modal>
);
